import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const viewsModule = () => import('./views/views.module').then( x=> x.ViewsModule );
const accountModule = () => import('./account/account.module').then(x => x.AccountModule);

const routes: Routes = [
  {
    path: '', 
    loadChildren: accountModule
  },
  {
    path: '', 
    loadChildren: viewsModule
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
